import functionUncurryThis from './function-uncurry-this.js';
import aCallable$1 from './a-callable.js';
import functionBindNative from './function-bind-native.js';

var uncurryThis = functionUncurryThis;
var aCallable = aCallable$1;
var NATIVE_BIND = functionBindNative;
var bind = uncurryThis(uncurryThis.bind); // optional / simple context binding

var functionBindContext = function (fn, that) {
  aCallable(fn);
  return that === undefined ? fn : NATIVE_BIND ? bind(fn, that) : function
    /* ...args */
  () {
    return fn.apply(that, arguments);
  };
};

export { functionBindContext as default };
